import { c as _c } from "react/compiler-runtime";
import { NO_TRANSLATE_CLASS, Text } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { useInfoBarSingleRowFrom } from "@components/common/info-bar/info-bar-layout-context";
/** A wrapping inline list of "<bold number> <label>" pairs, e.g. "3 Admins  12 Editors". */
export function InfoBarCounts(t0) {
  const $ = _c(7);
  const {
    counts
  } = t0;
  const singleRowFrom = useInfoBarSingleRowFrom();
  let t1;
  if ($[0] !== singleRowFrom) {
    t1 = {
      display: "flex",
      flexWrap: "wrap",
      columnGap: 2.5,
      maxWidth: {
        sm: "24rem",
        [singleRowFrom]: "none"
      }
    };
    $[0] = singleRowFrom;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== counts) {
    t2 = counts.map(_temp);
    $[2] = counts;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <Box sx={t1}>{t2}</Box>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp(t0) {
  const {
    label,
    value
  } = t0;
  return <Box key={label} sx={{
    display: "flex",
    alignItems: "baseline",
    gap: 1
  }}><Text variant="bodyM" className={NO_TRANSLATE_CLASS} sx={{
      fontSize: "1.125rem",
      fontWeight: "bold",
      color: "primary.main"
    }}>{value}</Text><Text variant="bodyM" sx={{
      fontSize: "0.8125rem",
      fontWeight: "regular",
      color: "text.secondary"
    }}>{label}</Text></Box>;
}